import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { FileUploadModule } from "@/store/modules/fileUpload.module";
import copy from "copy-to-clipboard";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { GridOptionModel } from "@/store/models/shared/gridOption";
import { interpret } from "xstate/lib/interpreter";
import fileListingMachine from "./machines/fileMangerMachine";
import DeleteComponent from "@/components/deleteComponent.vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let FileManager = /** @class */ (() => {
    let FileManager = class FileManager extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "File Manager";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "File Manager",
                    href: "#",
                },
            ];
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.totalCount = 0;
            this.copiedIndex = null;
            this.searchData = new GridOptionModel();
            this.fileId = "";
            this.columns = [
                {
                    field: "fileName",
                    label: "File Name",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Enter File Name",
                        autoComplete: "off",
                    },
                },
                {
                    field: "fileUrl",
                    label: "File URL",
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "col-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "fileName",
                    type: "asc",
                },
                page: 1,
                pageSize: 10,
            };
            //   MACHINE
            this.machine = fileListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.machineService.send({ type: "GETTING_FILES", searchData: searchData });
        }
        onRowClick() {
            return "";
        }
        deleteFile() {
            this.machineService.send({ type: "DELETING_FILE", fileId: this.fileId });
        }
        get rows() {
            return FileUploadModule.files;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get totalFiles() {
            return FileUploadModule.totalCount;
        }
        get fileURL() {
            return FileUploadModule.fileURL;
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        fileSelected2(e) {
            var newFiles = e.target.files || e.dataTransfer.files;
            if (!newFiles.length) {
                return null;
            }
            var filename = newFiles[0].name;
            this.machineService.send({ type: "GENERATE_SAS", fileName: filename, uploadedFile: newFiles[0] });
        }
        copyCode(code) {
            if (code != "") {
                copy(code);
                this.copiedIndex = code;
                setTimeout(() => {
                    this.copiedIndex = null;
                }, 2000);
            }
            else {
            }
        }
        showDeleteModal(id) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.fileId = id;
            this.machineService.send({ type: "DELETE_FILE", ispageChanged: isPageChanged });
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("loadedFiles")) {
                    this.totalCount = this.totalFiles;
                }
                if (this.state.matches("gettingFiles") && previousState.matches("loadedFiles.deletingFile")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    FileManager = __decorate([
        Component({
            name: "FileManager",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                DeleteComponent,
                SectionLoader,
            },
        })
    ], FileManager);
    return FileManager;
})();
export default FileManager;
